<dx-button 
  class="header-icon-button tertiary-button-dark-mode"
  icon=".\assets\img\Help-icon.svg" 
  hint="{{ 'appCommon.help' | translate }}" 
  (onClick)="help()">
</dx-button>